export class StripeServiceError extends Error {
  constructor(
    message: string,
    public code?: string,
    public status?: number
  ) {
    super(message);
    this.name = 'StripeServiceError';
  }
}

export const STRIPE_ERROR_MESSAGES = {
  AUTH_REQUIRED: 'Please sign in to continue',
  AUTH_ERROR: 'Authentication error',
  INVALID_PRICE_ID: 'Invalid subscription plan',
  MISSING_PRICE_ID: 'Price ID is required',
  MISSING_AUTH: 'Authentication required',
  CHECKOUT_FAILED: 'Failed to start checkout process',
  SERVICE_UNAVAILABLE: 'Payment service is temporarily unavailable. Please try again later.',
  PORTAL_FAILED: 'Failed to access billing portal',
  FUNCTION_ERROR: 'Service temporarily unavailable. Please try again later.',
  CORS_ERROR: 'Cross-origin request blocked. Please try again.',
  DEFAULT: 'An error occurred. Please try again.',
  INVALID_REQUEST: 'Invalid request format. Please try again.'
} as const;